import { Column } from '@inno-ui/table'

export enum TableColumnIds {
  Property = 'property',
  Value = 'value'
}

export const columns: Array<Column> = [
  {
    id: TableColumnIds.Property,
    label: '',
    isResizeable: false,
    initialWidth: 40
  },
  {
    id: TableColumnIds.Value,
    label: '',
    isResizeable: false
  }
]
